import { ProductsStateInterface } from '.';

function state(): ProductsStateInterface {
  return {
    products: [],
  };
}

export default state;
